import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const CERTS_QUIZ_PLANS_I18N_NAMESPACE =
  '@mc/checkout/experiments/prcng-1138_v1_certs_quiz_plans'

export const i18nInstance = registerI18nResources({
  namespace: CERTS_QUIZ_PLANS_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
